import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SUBJECT_TYPE } from '../monitoringConstants';
import { withLocalize, Translate } from 'react-localize-redux';
import BbCheckbox from '../../../components/styling/bbCheckbox';
import PropTypes from 'prop-types'

export const COLUMNS = {
    subjectReference: 'SubjectReference',
    warnings: 'Warnings',
    label: 'Label',
    isRegistered: 'IsRegistered',
    fullName: 'FullName',
    name: 'Name',

    // PortfolioPerson
    birthDate: 'BirthDate',
    dateOfBirth: 'DateOfBirth',

    // PortfolioCompany
    ident: 'Ident',
    companyId: 'CompanyId',

    // PortfolioDocument
    ownershipDocumentNumber: 'OwnershipDocumentNumber',
    cadastreUnitName: 'CadastreUnitName',
    municipalityName: 'MunicipalityName',
    regionName: 'RegionName',
    districtName: 'DistrictName',
};

export const SORT_TYPES = {
    asc: 'ASC',
    desc: 'DESC'
}

class PortfolioSubjectHeader extends React.Component {
    static propTypes = {
        subjectType: PropTypes.number.isRequired,
        onCheckAllClicked: PropTypes.func,
        checkAllValue: PropTypes.bool,
        isFirstLevel: PropTypes.bool,
        sortBy: PropTypes.string,
        sortType: PropTypes.string,
        onSortByColumn: PropTypes.func
    };

    static defaultProps = {
        checkAllValue: false,
        isFirstLevel: false,
        sortBy: null,
        sortType: SORT_TYPES.asc
    };

    render() {
        const { subjectType, checkAllValue, isFirstLevel } = this.props;

        if (subjectType === SUBJECT_TYPE.person) {
            if (isFirstLevel) {
                return (
                    <tr>
                        {this.renderHeadWithArrow(COLUMNS.subjectReference, "", "Monitoring.L1.ReferenceSubject")}
                        {this.renderHeadWithArrow(COLUMNS.fullName, "col-title", "Common.Title")}
                        {this.renderHeadWithArrow(COLUMNS.birthDate, "col-dob", "Monitoring.Add.DOB")}
                        {this.renderHeadWithArrow(COLUMNS.warnings, "col-warnings", "Search.MarketingSection.Warnings")}
                        {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                        {this.renderHeadWithArrow(COLUMNS.isRegistered, "col-in-db", "Portfolio.Search.IsInDb")}
                    </tr>
                );
            }

            return (
                <tr>
                    <th title={this.props.translate("Multiselect.CheckAll")} className="col-check-box">
                        <BbCheckbox id="all-chk" customStyle={{ justifyItems: "right" }} onChange={(v) => this.props.onCheckAllClicked(v)} value={checkAllValue} />
                    </th>
                    {this.renderHeadWithArrow(COLUMNS.dateOfBirth, "col-dob", "Monitoring.Add.DOB")}
                    {this.renderHeadWithArrow(COLUMNS.name, "", "Common.Title")}
                    {this.renderHeadWithArrow(COLUMNS.warnings, "col-warnings", "Search.MarketingSection.Warnings")}
                    {this.renderHeadWithArrow(COLUMNS.dateAddedFormatted, "", "Portfolio.Search.DateAdded")}
                    {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                    {this.renderHeadWithArrow(COLUMNS.isRegistered, "col-in-db", "Portfolio.Search.IsInDb")}
                    <th className="col-actions"><Translate id="Common.Actions" /></th>
                </tr>
            );
        }

        if (subjectType === SUBJECT_TYPE.company) {
            if (isFirstLevel) {
                return (
                    <tr>
                        {this.renderHeadWithArrow(COLUMNS.subjectReference, "", "Monitoring.L1.ReferenceSubject")}
                        {this.renderHeadWithArrow(COLUMNS.fullName, "", "Common.Title")}
                        {this.renderHeadWithArrow(COLUMNS.ident, "col-company-id", "Monitoring.Add.CompanyId")}
                        {this.renderHeadWithArrow(COLUMNS.warnings, "col-warnings", "Search.MarketingSection.Warnings")}
                        {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                    </tr>
                );
            }

            return (
                <tr>
                    <th title={this.props.translate("Multiselect.CheckAll")} className="col-check-box">
                        <BbCheckbox id="all-chk" customStyle={{ justifyItems: "right" }} onChange={(v) => this.props.onCheckAllClicked(v)} value={checkAllValue} />
                    </th>
                    {this.renderHeadWithArrow(COLUMNS.companyId, "col-company-id", "Monitoring.Add.CompanyId")}
                    {this.renderHeadWithArrow(COLUMNS.name, "", "Common.Title")}
                    {this.renderHeadWithArrow(COLUMNS.warnings, "col-warnings", "Search.MarketingSection.Warnings")}
                    {this.renderHeadWithArrow(COLUMNS.dateAddedFormatted, "", "Portfolio.Search.DateAdded")}
                    {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                    <th className="col-actions"><Translate id="Common.Actions" /></th>
                </tr>
            );
        }

        if (subjectType === SUBJECT_TYPE.document) {
            if (isFirstLevel) {
                return (
                    <tr>
                        {this.renderHeadWithArrow(COLUMNS.subjectReference, "", "Monitoring.L1.ReferenceSubject")}
                        {this.renderHeadWithArrow(COLUMNS.ownershipDocumentNumber, "col-ownership-deed-no", "PropertySk.Search.OwnershipDeedNo")}
                        {this.renderHeadWithArrow(COLUMNS.regionName, "", "PropertySk.Search.Region")}
                        {this.renderHeadWithArrow(COLUMNS.districtName, "", "PropertySk.Search.District")}
                        {this.renderHeadWithArrow(COLUMNS.municipalityName, "", "PropertySk.Search.Municipality")}
                        {this.renderHeadWithArrow(COLUMNS.cadastreUnitName, "", "PropertySk.Search.CadastreUnit")}
                        {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                        {this.renderHeadWithArrow(COLUMNS.isRegistered, "col-in-db", "Portfolio.Search.IsInDb")}
                    </tr>
                );
            }

            return (
                <tr>
                    <th title={this.props.translate("Multiselect.CheckAll")} className="col-check-box">
                        <BbCheckbox id="all-chk" customStyle={{ justifyItems: "right" }} onChange={(v) => this.props.onCheckAllClicked(v)} value={checkAllValue} />
                    </th>
                    {this.renderHeadWithArrow(COLUMNS.ownershipDocumentNumber, "col-ownership-deed-no", "PropertySk.Search.OwnershipDeedNo")}
                    {this.renderHeadWithArrow(COLUMNS.regionName, "", "PropertySk.Search.Region")}
                    {this.renderHeadWithArrow(COLUMNS.districtName, "", "PropertySk.Search.District")}
                    {this.renderHeadWithArrow(COLUMNS.municipalityName, "", "PropertySk.Search.Municipality")}
                    {this.renderHeadWithArrow(COLUMNS.cadastreUnitName, "", "PropertySk.Search.CadastreUnit")}
                    {this.renderHeadWithArrow(COLUMNS.dateAddedFormatted, "", "Portfolio.Search.DateAdded")}
                    {this.renderHeadWithArrow(COLUMNS.label, "col-label", "Monitoring.Add.Label")}
                    {this.renderHeadWithArrow(COLUMNS.isRegistered, "col-in-db", "Portfolio.Search.IsInDb")}
                    <th className="col-actions"><Translate id="Common.Actions" /></th>
                </tr>
            );
        }

        return null;
    }

    renderHeadWithArrow(column, columnClass, translateKey) {
        return <th className={`with-pointer ${columnClass}`} onClick={() => this.orderBy(column)}><Translate id={translateKey} />{this.showArrow(column)}</th>
    }

    orderBy(column) {
        if (column === this.props.sortBy) {
            this.props.onSortByColumn(this.props.sortBy, this.props.sortType === SORT_TYPES.asc ? SORT_TYPES.desc : SORT_TYPES.asc)
        } else {
            this.props.onSortByColumn(column, SORT_TYPES.asc)
        }
    }

    showArrow = (column) => {
        if (column !== this.props.sortBy)
            return null;

        if (this.props.sortType === SORT_TYPES.asc)
            return (<>&nbsp;<FontAwesomeIcon icon="arrow-up" className='search-result-icon svg-standard-fill' /></>);
        else if (this.props.sortType === SORT_TYPES.desc)
            return (<>&nbsp;<FontAwesomeIcon icon="arrow-down" className='search-result-icon svg-standard-fill' /></>);
        else
            return null;
    }
}

export default withLocalize(PortfolioSubjectHeader)